import { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../../../../firebase';
import SearchTableUsersOverview from './components/SearchTableUsersOverivew';

export default function UsersOverviewPage() {
  const [tableData, setTableData] = useState([]);
  const ROLE_LABELS = {
    tecnico:    'Técnico',
    supervisor: 'Supervisor',
    admin:      'Administrador',
    cliente:    'Cliente',
  };

  useEffect(() => {
    async function fetchUsers() {
      try {
        const querySnapshot = await getDocs(collection(db, 'users'));
        const data = querySnapshot.docs.map((doc) => {
          const user = doc.data();
          return {
            name: `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.displayName || '—',
            email: user.email || '',
            cargo: user.cargo || '',
            company: user.company || '',
            city: user.city || '',
            address: user.address || '',
            createdAt: user.createdAt ? new Date(user.createdAt) : null,
            permission: ROLE_LABELS[user.role] || 'Sem role',
            actions: doc.id,
          };
        });
        setTableData(data);
      } catch (err) {
        console.error('Erro ao carregar usuários:', err);
      }
    }

    fetchUsers();
  }, []);

  return <SearchTableUsersOverview tableData={tableData} />;
}
